module.exports = __webpack_public_path__ + "img/share-bg-19.e111a5aa.jpg";